exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".individuation_box[data-v-f2053dc0]{padding:24px}.avatar-uploader .el-upload[data-v-f2053dc0]{border:1px dashed #f7f7f7;border-radius:10px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-f2053dc0]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-f2053dc0]{font-size:28px;color:#8c939d;width:130px;height:130px;line-height:130px;text-align:center}", ""]);

// exports
